import { useLoaderData } from 'react-router-dom';

import CommunityHomeTemplate from 'src/components/templates/CommunityHome/CommunityHomeTemplate';
import { CommunityLayout } from 'src/components/templates/Layouts/CommunityLayout';
import type { FeaturedThreadsResult } from 'src/mapper/threadMapper';
import { MetaTag } from 'src/modules/meta/MetaTag';
import { getMetaData } from 'src/modules/meta/meta';
import { ROUTER_PATHS } from 'src/paths';
import { useTrackPageView } from 'src/provider/analytics';
import { useConfig } from 'src/provider/config';
import { ThreadsProvider } from 'src/provider/threads';

export interface CommunityHomeLoaderData {
  featuredThreads: FeaturedThreadsResult;
  pageNumber: number;
  isServer: boolean;
  isAuthenticated: boolean;
  init: true;
}

export function CommunityHome() {
  const { featuredThreads } = useLoaderData() as CommunityHomeLoaderData;
  const { language, absoluteUrl, brand } = useConfig();

  useTrackPageView();

  return (
    <CommunityLayout>
      <MetaTag
        {...getMetaData({
          page: ROUTER_PATHS.communityHome,
          language,
          absoluteUrl,
          brand,
        })}
      />
      <ThreadsProvider initialData={featuredThreads}>
        <CommunityHomeTemplate />
      </ThreadsProvider>
    </CommunityLayout>
  );
}
